import React, { useState, useContext, useEffect } from 'react'

const url = 'https://api2.splinterlands.com/cards/get_details';
const AppContext = React.createContext()

const AppProvider = ({ children }) => {

  const [loading, setLoading] = useState(true)
  const [cards, setCards] = useState([])
  const [menu, setMenu] = useState(true)

  const fetchCards = async () => {
    setLoading(true);
    try {
      const response = await fetch(url);
      const data = await response.json();      
      const cards = data;

      const fixEditions = (item) => {
        if (item.editions === '0,1') {
          item.editions = ['beta', 'alpha'];
        }
        if (item.editions === '1') {
          item.editions = ['beta'];
        }
        if (item.editions === '2') {
          item.editions = ['promo'];
        }
        if (item.editions === '3') {
          item.editions = ['reward'];
        }
        if (item.editions === '4') {
          item.editions = ['untamed'];
        }
        if (item.editions === '5') {
          item.editions = ['dice'];
        }
        if (item.editions === '6') {
          item.editions = ['gladius'];
        }
        if (item.editions === '7') {
          item.editions = ['chaos'];
        }

        //Filtering the reward cards to assign the set they belong to
        if (79 <= item.id) {
          if(item.id <= 223){
            if(item.editions[0] === 'reward'){
              item.reward = 'beta';
            }
          }
        }

        if (225 <= item.id) {
          if (item.id <= 289) {
            if (item.editions[0] === 'reward') {
              item.reward = 'untamed';
            }
          }
        }

        if (331 <= item.id) {
          if (item.id <= 351) {
            if (item.editions[0] === 'reward') {
              item.reward = 'chaos';
            }
          }
        }
      }

      const fixElement = (item) => {
        if (item.color === 'Red') {
          item.element = 'Fire';
        }
        if (item.color === 'Blue') {
          item.element = 'Water';
        }
        if (item.color === 'Green') {
          item.element = 'Earth';
        }
        if (item.color === 'White') {
          item.element = 'Life';
        }
        if (item.color === 'Black') {
          item.element = 'Death';
        }
        if (item.color === 'Gold') {
          item.element = 'Dragon';
        }
        if (item.color === 'Gray') {
          item.element = 'Neutral';
        }
      };

      const fixRarity = (item) => {
        if (item.rarity === 1) {
          item.rarity = 'Common';
        }
        if (item.rarity === 2) {
          item.rarity = 'Rare';
        }
        if (item.rarity === 3) {
          item.rarity = 'Epic';
        }
        if (item.rarity === 4) {
          item.rarity = 'Legendary';
        }
      };

      const createImageByLevel = (item) => {
        let card_name = encodeURIComponent(item.name.trim())
        let regular_card_images = []
        let alpha_regular_card_images = [];
        let gold_card_images = []
        let alpha_gold_card_images = [];
        let goldimg
        let img 
        let i = 0

        if(item.rarity === 'Common'){
          while (i < 10) {
            if(item.editions.includes('alpha')){
              img = 'https://d36mxiodymuqjm.cloudfront.net/cards_by_level/' + item.editions[1] + '/' + card_name + '_lv' + (i+1) + '.png';
              goldimg = 'https://d36mxiodymuqjm.cloudfront.net/cards_by_level/' + item.editions[1] + '/' + card_name + '_lv' + (i+1) + '_gold.png'
              alpha_regular_card_images.push(img);
              alpha_gold_card_images.push(goldimg);
            }
            img = 'https://d36mxiodymuqjm.cloudfront.net/cards_by_level/' + item.editions[0] + '/' + card_name + '_lv' + (i+1) + '.png';
            goldimg = 'https://d36mxiodymuqjm.cloudfront.net/cards_by_level/' + item.editions[0] + '/' + card_name + '_lv' + (i+1) + '_gold.png'
            regular_card_images.push(img);
            gold_card_images.push(goldimg);
            i++;
          }
        }

        if (item.rarity === 'Rare') {
          let i = 0;
          while (i < 8) {
            if(item.editions.includes('alpha')){
              img = 'https://d36mxiodymuqjm.cloudfront.net/cards_by_level/' + item.editions[1] + '/' + card_name + '_lv' + (i+1) + '.png';
              goldimg = 'https://d36mxiodymuqjm.cloudfront.net/cards_by_level/' + item.editions[1] + '/' + card_name + '_lv' + (i+1) + '_gold.png'
              alpha_regular_card_images.push(img);
              alpha_gold_card_images.push(goldimg);
            }
            img = 'https://d36mxiodymuqjm.cloudfront.net/cards_by_level/' + item.editions[0] + '/' + card_name + '_lv' + (i+1) + '.png';
            goldimg = 'https://d36mxiodymuqjm.cloudfront.net/cards_by_level/' + item.editions[0] + '/' + card_name + '_lv' + (i+1) + '_gold.png'
            regular_card_images.push(img);
            gold_card_images.push(goldimg);
            i++;
          }
        }

        if (item.rarity === 'Epic') {
          let i = 0;
          while (i < 6) {
            if(item.editions.includes('alpha')){
              img = 'https://d36mxiodymuqjm.cloudfront.net/cards_by_level/' + item.editions[1] + '/' + card_name + '_lv' + (i+1) + '.png';
              goldimg = 'https://d36mxiodymuqjm.cloudfront.net/cards_by_level/' + item.editions[1] + '/' + card_name + '_lv' + (i+1) + '_gold.png'
              alpha_regular_card_images.push(img);
              alpha_gold_card_images.push(goldimg);
            }
            img = 'https://d36mxiodymuqjm.cloudfront.net/cards_by_level/' + item.editions[0] + '/' + card_name + '_lv' + (i+1) + '.png';
            goldimg = 'https://d36mxiodymuqjm.cloudfront.net/cards_by_level/' + item.editions[0] + '/' + card_name + '_lv' + (i+1) + '_gold.png'
            regular_card_images.push(img);
            gold_card_images.push(goldimg);
            i++;
          }
        }

        if (item.rarity === 'Legendary') {
          let i = 0;
          while (i < 4) {
            if(item.editions.includes('alpha')){
              img = 'https://d36mxiodymuqjm.cloudfront.net/cards_by_level/' + item.editions[1] + '/' + card_name + '_lv' + (i+1) + '.png';
              goldimg = 'https://d36mxiodymuqjm.cloudfront.net/cards_by_level/' + item.editions[1] + '/' + card_name + '_lv' + (i+1) + '_gold.png'
              alpha_regular_card_images.push(img);
              alpha_gold_card_images.push(goldimg);
            }
            img = 'https://d36mxiodymuqjm.cloudfront.net/cards_by_level/' + item.editions[0] + '/' + card_name + '_lv' + (i+1) + '.png';
            goldimg = 'https://d36mxiodymuqjm.cloudfront.net/cards_by_level/' + item.editions[0] + '/' + card_name + '_lv' + (i+1) + '_gold.png'
            regular_card_images.push(img);
            gold_card_images.push(goldimg);
            i++;
          }
        }

        item.regular_images = regular_card_images;
        item.alpha_regular_images = alpha_regular_card_images;
        item.gold_images = gold_card_images;
        item.alpha_gold_images = alpha_gold_card_images;
      }

      const getFormat = (item) => {
        if (
          item.editions[0] === 'untamed' ||
          item.editions[0] === 'dice' ||
          item.editions[0] === 'chaos' ||
          item.reward === 'untamed' ||
          item.reward === 'chaos'
        ) {
          item.format = 'Modern';
        } else {
          if(item.editions[0] != 'gladius'){
            if (item.editions[0] === 'promo' && item.id >= 237) {
              item.format = 'Modern';
            } else {
              item.format = 'Wild';
            }
          } else {
            item.format = 'Brawl'
          }
        }
      }

      const getPower = (item) => {
        let power = []
        let power_alpha = []
        let power_beta = []

        let alpha = {
          Common: [30, 1500],
          Rare: [120, 6000],
          Epic: [600, 30000],
          Legendary: [3000, 150000]
        }

        let beta = {
          Common: [15, 750],
          Rare: [60, 3000],
          Epic: [300, 15000],
          Legendary: [1500, 75000]
        }

        let untamed = {
          Common: [10, 500],
          Rare: [40, 2000],
          Epic: [200, 10000],
          Legendary: [1000, 50000]
        }

        let chaos = {
          Common: [5, 125],
          Rare: [20, 500],
          Epic: [100, 2500],
          Legendary: [500, 12500]
        };

        if(item.editions.length > 1){
          if(item.rarity === "Common"){
            item.power = alpha.Common.concat(beta.Common)
          }
          if(item.rarity === "Rare"){
            item.power = alpha.Rare.concat(beta.Rare);
          }
          if(item.rarity === "Epic"){
            item.power = alpha.Epic.concat(beta.Epic);
          }
          if(item.rarity === "Legendary"){
            item.power = alpha.Legendary.concat(beta.Legendary);
          }
        }

        if(item.editions[0] === 'promo'){
          if(item.id <= 78){
            if (item.rarity === 'Common') {
              item.power = alpha.Common;
            }
            if (item.rarity === 'Rare') {
              item.power = alpha.Rare;
            }
            if (item.rarity === 'Epic') {
              item.power = alpha.Epic;
            }
            if (item.rarity === 'Legendary') {
              item.power = alpha.Legendary;
            }
          }
          if (item.id >= 114 && item.id <= 205) {
            if (item.rarity === 'Common') {
              item.power = beta.Common;
            }
            if (item.rarity === 'Rare') {
              item.power = beta.Rare;
            }
            if (item.rarity === 'Epic') {
              item.power = beta.Epic;
            }
            if (item.rarity === 'Legendary') {
              item.power = beta.Legendary;
            }
          }
          if (item.id === 237 || item.id === 238) {
            if (item.rarity === 'Common') {
              item.power = untamed.Common;
            }
            if (item.rarity === 'Rare') {
              item.power = untamed.Rare;
            }
            if (item.rarity === 'Epic') {
              item.power = untamed.Epic;
            }
            if (item.rarity === 'Legendary') {
              item.power = untamed.Legendary;
            }
          }
          if (item.id > 238) {
            if (item.rarity === 'Common') {
              item.power = chaos.Common;
            }
            if (item.rarity === 'Rare') {
              item.power = chaos.Rare;
            }
            if (item.rarity === 'Epic') {
              item.power = chaos.Epic;
            }
            if (item.rarity === 'Legendary') {
              item.power = chaos.Legendary;
            }
          }
        }

        if ((item.editions.includes('beta') && item.editions.length === 1) || item.reward === 'beta') {
          if (item.rarity === 'Common') {
            item.power = beta.Common;
          }
          if (item.rarity === 'Rare') {
            item.power = beta.Rare;
          }
          if (item.rarity === 'Epic') {
            item.power = beta.Epic;
          }
          if (item.rarity === 'Legendary') {
            item.power = beta.Legendary;
          }
        }

        if (item.editions[0] === 'untamed' || item.reward === 'untamed' || item.editions[0] === 'dice') {
          if (item.rarity === 'Common') {
            item.power = untamed.Common;
          }
          if (item.rarity === 'Rare') {
            item.power = untamed.Rare;
          }
          if (item.rarity === 'Epic') {
            item.power = untamed.Epic;
          }
          if (item.rarity === 'Legendary') {
            item.power = untamed.Legendary;
          }
        }

          if (item.editions[0] === 'chaos' || item.reward === 'chaos') {
            if (item.rarity === 'Common') {
              item.power = chaos.Common;
            }
            if (item.rarity === 'Rare') {
              item.power = chaos.Rare;
            }
            if (item.rarity === 'Epic') {
              item.power = chaos.Epic;
            }
            if (item.rarity === 'Legendary') {
              item.power = chaos.Legendary;
            }
          }

          if (item.editions[0] === 'gladius'){
            item.power = [0]
          }
      }

      const getAbilities = (item) => {

      }
      
      if(cards){
        const newCards = cards.map((item)=>{
        const {id,name,type,color,stats} = item;
        fixEditions(item);
        fixElement(item); 
        fixRarity(item);
        createImageByLevel(item);
        getFormat(item)
        getPower(item)
        getAbilities(item)
        return {
          id: id,
          name: name,
          type: type,
          rarity: item.rarity,
          editions: item.editions,
          color: color,
          reward: item.reward,
          element: item.element,
          foil: ['regular', 'gold'],
          images_regular: item.regular_images,
          images_alpha: item.alpha_regular_images,
          images_gold: item.gold_images,
          images_alpha_gold: item.alpha_gold_images,
          format: item.format,
          power: item.power,
          stats: stats
        };
        })
        console.log(newCards)
        setCards(newCards)
        // setCards(cards);
      } else {
        setCards([])
      }
      setLoading(false)
    } catch (error){
      console.log(error)
      setLoading(false);
    }
  }

  
  useEffect(() => {
    fetchCards()
  }, [])

  return (
    <>
      <AppContext.Provider
        value={{
          loading,
          cards,
          menu,
          setMenu,
          setCards,
        }}
      >
        {children}
      </AppContext.Provider>
    </>
  );
}
// make sure use
export const useGlobalContext = () => {
  return useContext(AppContext)
}

export { AppContext, AppProvider }
